import React from "react";
import { Col, Card } from "react-bootstrap";

const Categorias = ({index,toggleVisiblePlatillos,card,clicked}) => {
  return (
    <Col
      xs={12}
      sm={6}
      md={4}
      key={index}
      className="d-flex align-items-stretch mb-3" onClick={()=>clicked(card)}
    >
      <Card
        key={index}
        style={{ width: "150px", height: "200px" }}
        onClick={() => toggleVisiblePlatillos(card)}
      >
        <Card.Img variant="top" src={card.img} />
        {card.name}
      </Card>
    </Col>
  );
};

export default Categorias;
